import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { usePostApiRequest } from "../../../helpers/api";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import toast from "react-hot-toast";
import { Button, Form } from "react-bootstrap";

const tableHeadData = [
  "No",
  "Customer Name",
  "Link",
  "Incart Count",
  "Status",
  "Generate Date",
  "Expire Date",
  "Action",
];

const StoreLinkTable = ({ data, onEdit, refetch }) => {

  const postApiRequest = usePostApiRequest();
  const [copiedLinkId, setCopiedLinkId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const totalItems = data?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginatedData = data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const toggleActivator = async (index) => {
    const updated = [...data];
    const item = updated[index];
    const newStatus = item.StatusText === "Active" ? 0 : 1;
    updated[index].StatusText = newStatus;

    const payload = {
      id: item.Id,
      Status: newStatus,
    };

    try {
      const response = await postApiRequest({
        url: "/Customer/UpdateStoreLinkStatus",
        method: "POST",
        data: payload,
      });
      if (response.Status === true) {
        refetch();
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoadingData(false);
    }
  };

  const handleOpenDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setDeleteModal(true);
  };

  const handleDeleteStore = async () => {
    setIsLoadingData(true);
    const payload = {
      Id: selectedDeleteId,
    };

    try {
      const response = await postApiRequest({
        url: "/Customer/DeleteCustomerLinkDetail",
        method: "POST",
        data: payload,
      });
      if (response.Status === true) {
        refetch();
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoadingData(false);
    }
    setDeleteModal(false);
  };

  const copyLinkHandler = (id, link) => {
    if (link) {
      navigator.clipboard.writeText(link)
        .then(() => {
          setCopiedLinkId(id);
          setTimeout(() => setCopiedLinkId(null), 1000);
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
        });
    } else {
      console.warn('No link available to copy.');
      toast.error("No link available to copy.");
    }
  };

  return (
    <div className="mystock_page">
      {isLoadingData && <LoadingSpinner />}
      <div className="dashboard_content">
        <div className="pagination_selector">
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value={totalItems}>All</option>
          </select>
        </div>
        <div className="table_scroll_wrapper">
          <table>
            <thead>
              <tr>
                {tableHeadData.map((header, i) => (
                  <th key={i}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData?.map((stock, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                  <td style={{ width: "136px" }}>{stock.CustomerName}</td>
                  <td>
                    <div className="link_col">
                      <a
                        href={`https://jewelgalaxy.in/${stock.CustomerCode}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {stock.CustomerCode}
                      </a>
                      <Button
                        className="copy_button"
                        variant="outline-success"
                        onClick={() => copyLinkHandler(stock.Id, stock.Link)}
                      >
                        {copiedLinkId === stock.Id ? (
                          <>
                            Copied! <IoCheckmarkDoneSharp className="check_icon" />
                          </>
                        ) : (
                          "Copy Link"
                        )}
                      </Button>

                    </div>
                  </td>
                  <td style={{ width: "130px", height: "63px", display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <a
                      // href={`/cart/${stock.CustomerCode}`}
                      href="/cart"
                      rel="noopener noreferrer"
                    >
                      Cart Product
                    </a>
                    {stock.CartCount}
                  </td>
                  <td>
                    {
                      <Form.Check
                        type="switch"
                        onChange={() => toggleActivator(index)}
                        checked={stock.StatusText === "Active"}
                        className="custom-switch"
                      />
                    }
                  </td>
                  <td>{stock.CreatedDateFormatted}</td>
                  <td>{stock.ExpiredDateFormatted}</td>
                  <td className="action_table_cell">
                    <div className="action_cell_wrapper">
                      <div className="switch_wrapper">
                      </div>
                      <FaPencil
                        title="Edit"
                        className="edit_icon"
                        onClick={() => onEdit(stock)}
                      />
                      <FaTrash
                        title="Delete"
                        className="delete_icon"
                        onClick={() => handleOpenDeleteModal(stock.Id)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="customer_stock_pagination">
            <div className="btn_con">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="pagination_btn prev"
              >
                <IoIosArrowBack size="20px" />
              </button>
              <span>{currentPage}</span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="pagination_btn next"
              >
                <IoIosArrowForward size="20px" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {
        deleteModal && (
          <ConfirmationModal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            modalTitle="Confirmation"
            modalText="Are you sure you want to delete?"
            handleSubmit={handleDeleteStore}
            submitText="Delete"
          />
        )
      }
    </div >
  );
};

export default StoreLinkTable;
